import { useTranslation } from "react-i18next";
import { ActionsType } from "@/components/custom/data-table/buttons/data-table-actions";
import {
  DeleteAction,
  OperationalHoursAction,
  UploadCatalogAction,
} from "./-site-groups-actions-components";
import { PiTrash, PiClock, PiUpload } from "react-icons/pi";
import { usePermissions } from "@/hooks/use-permissions";

// Every entry is gated like its route (ID-7306): a role that opens an action its route refuses gets a 403, which
// sends a user to the Unauthorized page.
export const useActions = (): ActionsType => {
  const { t } = useTranslation();
  const { permissions } = usePermissions();

  return [
    // DELETE /site-groups/:id is siteGroups.delete, which SiteManager lacks.
    permissions.siteGroups.delete && {
      label: t("delete"),
      title: t("deleteSiteGroups"),
      actionContent: DeleteAction,
      icon: PiTrash,
    },
    // PATCH /site-groups/operational-hoursBulk is siteGroups.update, which SiteManager lacks.
    permissions.siteGroups.update && {
      label: t("operationalHours"),
      title: t("updateOperationalHours"),
      actionContent: OperationalHoursAction,
      icon: PiClock,
    },
    // POST /catalog/upload is catalog.edit, which Tech, Owner and SiteManager lack.
    permissions.catalog.edit && {
      label: t("uploadCatalog"),
      title: t("uploadCatalog"),
      actionContent: UploadCatalogAction,
      icon: PiUpload,
    },
  ].filter(Boolean) as ActionsType;
};
